<template>
  <section class="section" id="overview">
    <div class="section-inner">
      <div class="section-header reveal">
        <div class="section-number">01 / OVERVIEW</div>
        <h2 class="section-title">展会概况</h2>
        <p class="section-desc">立足安徽、辐射长三角，打造养老产业展示、招商对接与惠民服务核心平台</p>
      </div>
      <div class="overview-grid">
        <div class="overview-content reveal">
          <p v-for="(para, index) in paragraphs" :key="index">{{ para }}</p>
        </div>
        <div class="overview-highlights reveal">
          <div class="highlight-card" v-for="item in highlights" :key="item.title">
            <div class="highlight-icon">{{ item.icon }}</div>
            <div class="highlight-text">
              <h4>{{ item.title }}</h4>
              <p>{{ item.desc }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'OverviewSection',
  data() {
    return {
      paragraphs: [
        '2026安徽省养老博览会是经商务部核准，由省民政厅、省卫生健康委、省发展改革委、省商务厅、省贸促会多部门联合主办，是长三角区域极具影响力的养老产业展示、招商对接与惠民服务核心平台。展会持续围绕"皖美养老，人生晚晴"核心主题，立足安徽养老产业发展实际，深度联动长三角康养资源，全方位展示养老事业建设成果与银发经济创新业态，助力全省养老事业与养老产业双向协同、高质量发展。',
        '展会聚焦养老全产业链生态构建，采用展览展示+精准招商+惠民体验的多元办展模式，汇聚全国康养品牌、政企机构、行业协会及专业采购商参展参会，全面覆盖政府养老成果、智慧康养、适老改造、康复照护、中医药康养、旅居文旅、医养服务、养老金融等核心板块，精准呈现居家、社区、机构、旅居四大养老场景的新技术、新产品、新方案、新模式。',
        '诚挚邀请各界同仁齐聚合肥，共话养老新机遇，共绘银发新蓝图，为安徽省养老事业与产业的蓬勃发展贡献智慧与力量。'
      ],
      highlights: [
        {
          icon: '🏛️',
          title: '权威主办',
          desc: '经商务部核准，省民政厅、省卫生健康委、省发改委、省商务厅、省贸促会多部门联合主办，权威性强。'
        },
        {
          icon: '🚀',
          title: '全产业链',
          desc: '聚焦养老全产业链生态构建，覆盖智慧康养、适老改造、康复照护、中医药康养、旅居文旅、医养服务、养老金融等核心板块。'
        },
        {
          icon: '🤝',
          title: '多元办展',
          desc: '采用展览展示+精准招商+惠民体验的多元办展模式，汇聚康养品牌、政企机构、行业协会及专业采购商参展参会。'
        },
        {
          icon: '📢',
          title: '全媒体传播',
          desc: '联动主流媒体、行业平台、社交矩阵进行全方位宣传报道。'
        }
      ]
    };
  },
  mounted() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    this.$el.querySelectorAll('.reveal').forEach(el => observer.observe(el));
  }
};
</script>

<style scoped>
  .section {
    padding: 120px 32px;
    position: relative;
  }

  .section-inner {
    max-width: 1200px;
    margin: 0 auto;
  }

  .section-header {
    text-align: center;
    margin-bottom: 72px;
  }

  .section-number {
    display: inline-block;
    font-family: var(--font-serif);
    font-size: 14px;
    color: var(--color-primary);
    font-weight: 700;
    letter-spacing: 3px;
    margin-bottom: 16px;
    position: relative;
    padding: 0 40px;
  }

  .section-number::before,
  .section-number::after {
    content: '';
    position: absolute;
    top: 50%;
    width: 30px;
    height: 1px;
    background: var(--color-primary-light);
  }

  .section-number::before { left: 0; }
  .section-number::after { right: 0; }

  .section-title {
    font-family: var(--font-serif);
    font-weight: 900;
    font-size: clamp(32px, 4vw, 48px);
    color: var(--color-text);
    margin-bottom: 16px;
    line-height: 1.2;
  }

  .section-desc {
    font-size: 16px;
    color: var(--color-text-light);
    max-width: 640px;
    margin: 0 auto;
    line-height: 1.8;
  }

  .reveal {
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.8s ease, transform 0.8s ease;
  }

  .reveal.visible {
    opacity: 1;
    transform: translateY(0);
  }

  .overview-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 48px;
    align-items: start;
  }

  .overview-content {
    padding-right: 24px;
  }

  .overview-content p {
    font-size: 15px;
    color: var(--color-text-light);
    line-height: 1.9;
    margin-bottom: 20px;
    text-align: justify;
  }

  .overview-content p:first-child::first-letter {
    font-family: var(--font-serif);
    font-size: 48px;
    font-weight: 700;
    color: var(--color-primary);
    float: left;
    line-height: 1;
    margin-right: 10px;
    margin-top: 4px;
  }

  .overview-highlights {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .highlight-card {
    padding: 28px;
    background: var(--color-white);
    border-radius: var(--radius-md);
    border: 1px solid var(--color-border);
    box-shadow: var(--shadow-sm);
    display: flex;
    gap: 20px;
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;
  }

  .highlight-card::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 4px;
    background: linear-gradient(180deg, var(--color-primary), var(--color-accent));
    transform: scaleY(0);
    transform-origin: bottom;
    transition: transform 0.4s ease;
  }

  .highlight-card:hover {
    transform: translateX(4px);
    box-shadow: var(--shadow-md);
  }

  .highlight-card:hover::before {
    transform: scaleY(1);
  }

  .highlight-icon {
    width: 56px;
    height: 56px;
    background: linear-gradient(135deg, var(--color-primary-light), var(--color-accent-light));
    border-radius: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 26px;
    flex-shrink: 0;
  }

  .highlight-text h4 {
    font-family: var(--font-serif);
    font-weight: 700;
    font-size: 18px;
    margin-bottom: 8px;
    color: var(--color-text);
  }

  .highlight-text p {
    font-size: 14px;
    color: var(--color-text-light);
    line-height: 1.7;
    margin: 0;
  }

  @media (max-width: 768px) {
    .section { padding: 80px 24px; }
    .overview-grid { grid-template-columns: 1fr; gap: 32px; }
  }
</style>
